export default "__VITE_ASSET__CzSAX3mG__"